import { getOrCreateId } from './domains/id';
import { ingestTradeIn, egressLastTradeIn } from './domains/trade-in';
import { egressConsumerId, removeConsumerId, ingestConsumerId } from './domains/consumer-id';
/**
 * Looks for a Consumer UUID in storage and creates one if it does not exist
 */
export function getId() {
    return getOrCreateId();
}
/**
 * Ingests a trade in and persists it to local storage for future retrieval.
 * Validates the data against the `TradeIn` schema, will throw an error if
 * the data provided is invalid or if it is unable to save.
 */
export function emitTradeIn(data) {
    return ingestTradeIn(data);
}
/**
 * Retrieves the last Trade In from localStorage.
 * Will return an empty object if no Trade In was found.
 */
export function fetchLastTradeIn() {
    return egressLastTradeIn();
}
/**
 * Removes the last Trade In from localStorage.
 */
export async function discardTradeIn() {
    ingestTradeIn({});
}
export function setConsumerId(consumerId) {
    return ingestConsumerId(consumerId);
}
export function getConsumerId() {
    return egressConsumerId();
}
export function discardConsumerId() {
    return removeConsumerId();
}
